import includes from 'lodash-es/includes';

import { WrappedControlProps } from 'app/components/Controls/WrappedControlProps';
import { DictionaryEntry, DictionaryEntryKey } from 'app/services/dict.service';

export function useCheckboxGroupControl({
  dictionary,
  disabledDictionaryEntries,
  input,
  onClick,
  onValueChange,
}: WrappedControlProps & {
  disabledDictionaryEntries: Array<string>;
}) {
  const handleChange = (value: DictionaryEntryKey) => {
    if (isDictionaryEntryDisabled(value)) {
      return;
    }

    let newValue: Array<DictionaryEntryKey> = [];
    const checked = includes(input.value, value);

    if (Array.isArray(input.value)) {
      newValue = [...input.value];
    }

    if (!checked) {
      newValue.push(value);
    } else {
      newValue.splice(newValue.indexOf(value), 1);
    }

    input.onChange(newValue);

    if (onValueChange) {
      onValueChange(newValue, true);
    }
  };

  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };

  const renderCheckboxes = (
    renderItemFunction: (entry: DictionaryEntry) => JSX.Element
  ) => dictionary && dictionary.map(renderItemFunction);

  const isChecked = (entryKey: DictionaryEntryKey) => {
    return includes(input.value, entryKey);
  };

  const isDictionaryEntryDisabled = (entryKey: DictionaryEntryKey) => {
    return includes(disabledDictionaryEntries, entryKey);
  };

  return {
    handleChange,
    handleClick,
    isChecked,
    isDictionaryEntryDisabled,
    renderCheckboxes,
  };
}
